import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

import { AiSummaryVariantsComponent } from '../ai-summary-variants/ai-summary-variants.component';
import { AiSummaryComponent } from './ai-summary.component';
import { AiSummaryLoadingComponent } from './ai-summary-loading.component';

@NgModule({
  declarations: [AiSummaryComponent, AiSummaryLoadingComponent, AiSummaryVariantsComponent],
  imports: [CommonModule, MatIconModule, FormsModule],
  exports: [AiSummaryComponent, AiSummaryVariantsComponent]
})
export class AiSummaryModule {}
